var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import config from "@/config";
export var MAX_EXP = function (level) {
    return level < 2 ? (level + 1) * 1000 : 10000;
};
var Title = /** @class */ (function (_super) {
    __extends(Title, _super);
    function Title(scene, x, y, data) {
        var _this = _super.call(this, scene, x, y) || this;
        _this.data_player = data;
        var _a = _this.data_player, game = _a.game, position = _a.position, user = __rest(_a, ["game", "position"]);
        _this.containerLevelBadge = new Phaser.GameObjects.Container(scene, -130, 0);
        _this.textLevel = new Phaser.GameObjects.Text(scene, 0, 0, "" + (game.level + 1), {
            fontFamily: config.graphics.fontFamily,
        });
        _this.arcRatioExp = new Phaser.GameObjects.Graphics(scene);
        _this.textName = new Phaser.GameObjects.Text(scene, 0, 0, user.username.substring(0, 7), {
            fontFamily: config.graphics.fontFamily,
        });
        _this.setScale(4);
        _this.textLevel.setOrigin(0.5);
        _this.textName.setOrigin(0.5);
        _this.textLevel.setFontSize(28);
        _this.textName.setFontSize(42);
        _this.arcRatioExp.lineStyle(4, 0x00aaff, 1);
        _this.arcRatioExp.beginPath();
        _this.arcRatioExp.arc(0, 0, 24, Phaser.Math.DegToRad(0), Phaser.Math.DegToRad((game.exp * 360) / MAX_EXP(game.level)), false);
        var badge = new Phaser.GameObjects.Arc(scene, 0, 0, 26, 0, 360, false, 0x1a1a20);
        badge.setStrokeStyle(4, 0x00aaff);
        // badge.isStroked = true;
        _this.arcRatioExp.strokePath();
        _this.arcRatioExp.rotation = (-1 * Math.PI) / 2;
        _this.containerLevelBadge.add(badge);
        _this.containerLevelBadge.add(_this.arcRatioExp);
        _this.containerLevelBadge.add(_this.textLevel);
        _this.add(_this.containerLevelBadge);
        _this.add(_this.textName);
        return _this;
    }
    Title.prototype.destroy = function () {
        this.containerLevelBadge.destroy();
        this.textLevel.destroy();
        this.arcRatioExp.destroy();
        this.textName.destroy();
    };
    Title.prototype.setLevel = function (level) {
        this.data_player.game.level = level;
        this.textLevel.text = "" + (level + 1);
        level >= 10 && this.textLevel.setFontSize(24);
    };
    Title.prototype.setExp = function (exp) {
        this.arcRatioExp.clear();
        this.arcRatioExp.fillStyle(0x00aaff, 1);
        this.arcRatioExp.beginPath();
        this.arcRatioExp.moveTo(0, 0);
        this.arcRatioExp.arc(0, 0, 24, Phaser.Math.DegToRad(0), Phaser.Math.DegToRad((exp * 360) / MAX_EXP(this.data_player.game.level)), false);
        // this.arcRatioExp.strokePath();
        this.arcRatioExp.closePath();
        this.arcRatioExp.fillPath();
    };
    return Title;
}(Phaser.GameObjects.Container));
export default Title;
